module.exports = __webpack_public_path__ + "img/logo-ciudadelahospitalaria.ae663e30.png";